<template>
    <div class="about-header">
        <div class="header-content">
            <div class="content-first">
                <div style="text-align:center"><span style="color: #262A47;font-size:40px">公司简介</span></div>
            </div>
            <div style="display: flex;justify-content: center;margin-top:31px">
                <div style="width: 1030px;height: 77px;font-size: 18px;color: #262A47;line-height: 30px;margin-left:3px">
                    <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;红杉会议是红杉云旗下定位为私有化部署视频会议系统方案的品牌，核心团队来自于思科WebEx，有10年以上视频通讯方面的产品研发和云服务运营经验，是国内最早提供云视频服务团队之一。红杉会议拥有完全的自主知识产权产品和专利技术，提供简单灵活的私有化部署方式、全平台的支持能力、丰富的SDK接口、兼容各种网络情况和应用场景的使用。红杉会议拥有广泛的合作伙伴体系和行业方案能力，先后与华为、阿里云、海康威视、上海电信、中国联通、泛微、浪潮、中国电子、飞利浦医疗、巴可医疗等合作，为政府、军警、医疗、教育、企业等行业提供整体音视频解决方案。</span>
               </div>
            </div>
            <div style="font-size: 40px;color: #262A47;margin-top:97px;margin-bottom:20px;text-align:center">
                公司荣誉
            </div>
            <div class="about-img" style="margin-top: 30px;margin-bottom: 40px;">
                <img src="@/assets/image/jianjie.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>
<style>
    *{
        margin: 0;
        padding: 0;
    }
</style>
<style lang="scss">
    .about-header{
        width: 100%;
        .header-content{
            width: 1200px;
            margin: 0 auto;
            padding-right: 15px;
            .content-first{
                margin-top: 55px;
            }
        }
    }
</style>